import script from "./BaseTemplateHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTemplateHeader.vue?vue&type=script&setup=true&lang=js"

import "./BaseTemplateHeader.vue?vue&type=style&index=0&id=4bf65870&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bf65870"]])

export default __exports__
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import qInstall from "../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPopupProxy});
